import React, { useState, useEffect } from 'react';
import { eventList } from '@/definition/EVENT_LIST';
import { State } from '@/redux/state';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export const Ed132 = (): React.ReactElement => {
  const isAuth = useSelector((state: State) => state.isAuth);
  const [isLogin, setIsLogin] = useState(false);
  const [deadline, setDeadline] = useState(false);

  useEffect(() => {
    if (isAuth) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }
  }, [isAuth]);

  useEffect(() => {
    const e = eventList.find(e => e.id === "0132");
    if (!e) return;
    const yyyymmdd = e.deadlineDate.split(' ')[0];
    const deadlineDate = new Date(`${yyyymmdd.replace(/-/g, "/")} 12:00:00`);
    const now = new Date;
    if (now > deadlineDate) setDeadline(true);
  }, []);

  const style = {
    img: 'border-gray-300 border-r border-b border-l'
  };
  return (
    <div className="event-contents">
      <div className="event-detail">
        <div className="md:-mx-16 sm:-mx-16">
          <img className={style.img} src="../images/Top/event/event_0132_mv.jpg" width="978" height="504" alt="" />
        </div>
        <h1 className="mt-56 sm:mt-30 sm:mb-8 text-29_46 sm:text-18_24 font-bold text-center">2/18（火）19:30 -<br />
        〈令和最新版〉<br />
          需要のある<br className="md:hidden lg:hidden" />Webディレクターになるには？</h1>
        {deadline &&
          <section className="mt-30 sm:mt-24 mb-40 sm:mb-18">
            <div className="flex flex-col items-center justify-center px-16 py-25 sm:p-16 bg-gray-100">
              <p className="mb-10 lg:mb-16 text-18_33 sm:text-14_21 font-bold">このセミナーの受付は終了しています。</p>
              <p className="text-16_28 sm:text-14_21">定期的にセミナーを開催しておりますので、<br className="sm:hidden" />最新の開催情報は<a className="textLink" href="../event/">こちら</a>よりご確認ください。</p>
            </div>
          </section>
        }
        <section className='mt-80 sm:mt-55'>
          <h2 className='text-24_24 sm:text-15_22 font-bold mt-80 sm:mt-55 mb-40 sm:mb-18 sm:pb-6'>セミナーについて</h2>
          <div className="mt-30 sm:mt-16 mb-30 sm:mb-18 box-line">
            <img src="../images/Top/event/event_0049_image.jpg" width="980" height="374" alt="" />
          </div>
          <p className="text-16_28 sm:text-14_21 mt-30 sm:mt-16 mb-40 sm:mb-18">
            マッチボックスユーザーの皆さまに向けたセミナーを開催し、転職活動に向けてのご支援するにあたり、現在業界内でWebディレクターの需要がとても高くなっております。またWebディレクター不足がささやかれてもいる中、今回は現在どんなWebディレクターが求められているか、に焦点を当ててセミナーを開催させていただきます。<br />
            <br />
            ご登壇は現在Webディレクターとして活躍中の幸野剛士（タケ）氏です。需要のあるWebディレクターって？今後どんなスキルが必要？などの切り口で、令和最新版のディレクター論をお話しいただきます。<br />
            質疑応答の時間もございますので、Webディレクターとして転職活動、キャリアアップに関するお悩みを解決する機会としてぜひご参加ください。</p>
        </section>
        {!deadline && !isLogin &&
          <section className='mt-80 sm:mt-55 mb-40 sm:mb-18'>
            <div className='flex flex-col items-center justify-center'>
              <p className='mb-6 md:mb-12 lg:mb-12 text-16_28 sm:text-14_21'>MATCHBOXのアカウントをお持ちでない方</p>
              <p className='base-button mb-15 md:mb-24 lg:mb-24 text-16_28 sm:text-14_21'>
                <Link className='button size-m theme-secondary flex items-center flex-col font-bold' to="/entry"
                >
                  アカウントを新規で作成する
                  <span className='text-14_21 sm:text-12_20 text-center'>※セミナー参加にはMATCHBOXの事前登録が必要です。</span>
                </Link>
              </p>
              <p className='text-16_28 sm:text-14_21'>アカウントをお持ちの方は<Link className='textLink font-bold' to="/login">こちら</Link>からログイン後、お申込みください。</p>
            </div>
          </section>
        }
        <section>
          <h2 className='text-24_24 sm:text-15_22 font-bold mt-80 sm:mt-55 mb-40 sm:mb-18 sm:pb-6'>以下に該当する方にオススメです。</h2>
          <div className="mt-30 sm:mt-16 p-40 sm:p-24 box-line text-left">
            <ul className="text-16_28 sm:text-14_21">
              <li className="flex mb-4">
                <span><i className="mbx-naviInpage-item-icon mbx-icon mbx-icon-Done"></i></span><span>Webディレクターとして転職したい</span>
              </li>
              <li className="flex mb-4">
                <span><i className="mbx-naviInpage-item-icon mbx-icon mbx-icon-Done"></i></span><span>Webディレクターとしてキャリアアップしたい</span>
              </li>
              <li className="flex mb-4">
                <span><i className="mbx-naviInpage-item-icon mbx-icon mbx-icon-Done"></i></span><span>現在需要があるWebディレクターについて知りたい</span>
              </li>
              <li className="flex mb-4">
                <span><i className="mbx-naviInpage-item-icon mbx-icon mbx-icon-Done"></i></span><span>自身の今後のキャリアの方向性を定めたい</span>
              </li>
              <li className="flex">
                <span><i className="mbx-naviInpage-item-icon mbx-icon mbx-icon-Done"></i></span><span>セミナーを踏まえて転職の相談をしたい方</span>
              </li>
            </ul>
          </div>
        </section>
        {!deadline && !isLogin &&
          <section className='mt-80 sm:mt-55 mb-40 sm:mb-18'>
            <div className='flex flex-col items-center justify-center'>
              <p className='mb-6 md:mb-12 lg:mb-12 text-16_28 sm:text-14_21'>MATCHBOXのアカウントをお持ちでない方</p>
              <p className='base-button mb-15 md:mb-24 lg:mb-24 text-16_28 sm:text-14_21'>
                <Link className='button size-m theme-secondary flex items-center flex-col font-bold' to="/entry"
                >
                  アカウントを新規で作成する
                  <span className='text-14_21 sm:text-12_20 text-center'>※セミナー参加にはMATCHBOXの事前登録が必要です。</span>
                </Link>
              </p>
              <p className='text-16_28 sm:text-14_21'>アカウントをお持ちの方は<Link className='textLink font-bold' to="/login">こちら</Link>からログイン後、お申込みください。</p>
            </div>
          </section>
        }
        <section>
          <h2 className='text-24_24 sm:text-15_22 font-bold mt-80 sm:mt-55 mb-40 sm:mb-18 sm:pb-6'>講師プロフィール</h2>
          <div className='event-instructor box-line mb-30 sm:p-16'>
            <div className="instructor-photo">
              <img src="../images/Top/event/event_0132_prof.jpg" alt="" />
            </div>
            <dl className="instructor-prof sm:mt-16">
              <dt className="instructor-name text-16_28 font-bold">
                幸野 剛士（タケ）（KONO TAKESHI）
              </dt>
              <dd className="instructor-position text-16_28 sm:text-14_21 mb-40 sm:mb-18">
                Webディレクター
              </dd>
              <dd className="instructor-career text-16_28 sm:text-14_21">
                1992年生。栃木県出身。複数の制作会社を経て2024年10月に独立。主に車、製造、金融といったtoB業界のWebディレクターとして活動中。「集まれ！Webディレクターの森」を主宰し、コミュニティ運営やオフライン・オンラインイベントを展開している。
              </dd>
            </dl>
          </div>
        </section>
        <section>
          <h2 className="text-24_24 sm:text-15_22 font-bold mt-80 sm:mt-55 mb-40 sm:mb-18 sm:pb-6">当日スケジュール</h2>
          <table className="index timetable text-16_28 sm:text-14_21 mb-30 sm:mb-12">
            <tbody>
              <tr>
                <th scope="row" className="bg-gray-50 font-normal whitespace-nowrap">
                  <span className="sm:block">19：30</span><span className="sm:block">～</span><span className="sm:block">21：00</span>
                </th>
                <td>
                  <ul className="text-16_28 sm:text-14_21">
                    <li className="flex"><span>・</span><span>自己紹介</span></li>
                    <li className="flex"><span>・</span><span>そもそも需要のある(選ばれ続ける) Webディレクターってどんな人？</span></li>
                    <li className="flex"><span>・</span><span>実際にWebディレクターの需要は増えている？</span></li>
                    <li className="flex"><span>・</span><span>具体的な求人事例の紹介</span></li>
                    <li className="flex"><span>・</span><span>この事例を見るに「運用保守しかできないWebディレクター」はきびしい</span></li>
                    <li className="flex"><span>・</span><span>給与レンジ別で見る求められるスキル</span></li>
                    <li className="flex"><span>・</span><span>今後のWebディレクターに何が必要か</span></li>
                    <li className="flex"><span>・</span><span>では今どうなのか？同じように現在の求人を見てみよう</span></li>
                    <li className="flex"><span>・</span><span>実際に私がどういう風にAIを活用しているか少しだけ紹介</span></li>
                    <li className="flex"><span>・</span><span>今後ますます「広く浅く」ではなく「広く浅く＋深く（数か所）」が求められる</span></li>
                    <li className="flex"><span>・</span><span>まとめ</span></li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </section >
        {!deadline && !isLogin &&
          <section className='mt-80 sm:mt-55 mb-40 sm:mb-18'>
            <div className='flex flex-col items-center justify-center'>
              <p className='mb-6 md:mb-12 lg:mb-12 text-16_28 sm:text-14_21'>MATCHBOXのアカウントをお持ちでない方</p>
              <p className='base-button mb-15 md:mb-24 lg:mb-24 text-16_28 sm:text-14_21'>
                <Link className='button size-m theme-secondary flex items-center flex-col font-bold' to="/entry"
                >
                  アカウントを新規で作成する
                  <span className='text-14_21 sm:text-12_20 text-center'>※セミナー参加にはMATCHBOXの事前登録が必要です。</span>
                </Link>
              </p>
              <p className='text-16_28 sm:text-14_21'>アカウントをお持ちの方は<Link className='textLink font-bold' to="/login">こちら</Link>からログイン後、お申込みください。</p>
            </div>
          </section>
        }
        <section className="mb-64 sm:mb-48">
          <h2 className="text-24_24 sm:text-15_22 font-bold mt-80 sm:mt-55 sm:mb-8 sm:pb-6 text-left">開催概要</h2>
          <table className="summary text-16_28 sm:text-14_21">
            <tbody>
              <tr>
                <th scope="row" className="font-normal text-left">開催日時</th>
                <td>2025/2/18（火）19:30～<br />
                  [入室開始] 19:20～</td>
              </tr>
              <tr>
                <th scope="row" className="font-normal text-left">開催方法</th>
                <td>Zoom開催<br />参加者の皆さまには別途URLをお送りします。</td>
              </tr>
              <tr>
                <th scope="row" className="font-normal text-left">参加費</th>
                <td>無料</td>
              </tr>
              <tr>
                <th scope="row" className="font-normal text-left">応募手順</th>
                <td>
                  <dl>
                    <dt className="mb-18 sm:mb-8">1.参加申し込み</dt>
                    <dd className="mb-38 sm:mb-16">MATCHBOXへログインいただき、お申し込みください。（アカウント作成は<a className="textLink"
                      href="https://matchbox.work/entry">こちら</a>から）</dd>
                    <dt className="mb-18 sm:mb-8">2.ご連絡</dt>
                    <dd className="mb-38 sm:mb-16">マッチボックス セミナー事務局より、MATCHBOXに登録していただいているメールアドレス宛に当日の詳細のご連絡差し上げます。</dd>
                    <dt className="mb-18 sm:mb-8">3.開催当日</dt>
                    <dd>当日はZoomにて開催いたします。</dd>
                  </dl>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        {!deadline && !isLogin &&
          <section className='mt-80 sm:mt-55 mb-40 sm:mb-18'>
            <div className='flex flex-col items-center justify-center'>
              <p className='mb-6 md:mb-12 lg:mb-12 text-16_28 sm:text-14_21'>MATCHBOXのアカウントをお持ちでない方</p>
              <p className='base-button mb-15 md:mb-24 lg:mb-24 text-16_28 sm:text-14_21'>
                <Link className='button size-m theme-secondary flex items-center flex-col font-bold' to="/entry"
                >
                  アカウントを新規で作成する
                  <span className='text-14_21 sm:text-12_20 text-center'>※セミナー参加にはMATCHBOXの事前登録が必要です。</span>
                </Link>
              </p>
              <p className='text-16_28 sm:text-14_21'>アカウントをお持ちの方は<Link className='textLink font-bold' to="/login">こちら</Link>からログイン後、お申込みください。</p>
            </div>
          </section>
        }
        <section className='mt-80 sm:mt-55'>
          <h3 className='text-18_24 sm:text-14_21 font-bold'>開催について</h3>
          <p className='text-16_28 sm:text-14_21 mt-30 sm:mt-16'>Web・IT業界で必要不可欠な存在であるWebディレクター・Webデザイナーの皆さまを支援するために、日本ディレクション協会で受講者累計2, 000名を超える「0からのWebディレクション講座」を生み出したメンバーでもある一般社団法人ディレクションサポート協会 会長の助田正樹氏と連携して、Webの現場最前線で働くロールモデルの方々をゲストとしてお呼びし、キャリアを考えるために有益な情報提供を開始しています。</p>
        </section >
        <section className="mt-80 sm:mt-55 p-40 sm:p-24 bg-gray-50 text-left">
          <h3 className="text-18_24 sm:text-14_21 font-bold">注意点</h3>
          <ul className="mt-16 text-16_28 sm:text-14_21">
            <li className="flex"><span>・</span><span>セミナー開催用のZoomURLはセミナー前日・当日にメールにてお送りします。</span></li>
            <li className="flex"><span>・</span><span>セミナー開催用のZoomURLをお知らせするメールはマッチボックスにご登録いただいているメールアドレス（ログインID）に送付しております。</span></li>
            <li className="flex"><span>・</span><span>受信フォルダ・迷惑メール設定、フォルダの受信容量やドメインの許可（@matchbox.work）の確認をお願いいたします。</span></li>
            <li className="flex"><span>・</span><span>マッチボックス登録時のアドレス、またはセミナー申込み時に入力したアドレスにURLへ届いていない場合は<a className='textLink' href='https://survey.mynavi.jp/cre/?enq=2va0sJC992s%3d' target={'_blank'} rel="noreferrer">こちら<i className="mbx-icon mbx-icon-External_link"></i></a>からお問い合わせください。</span></li>
          </ul>
        </section>
        <div className='back_event-list flex flex-col items-center justify-center mt-120 sm:mt-55'>
          <div className="base-button isTextLink">
            <a className="button size-s theme-link flex items-center" href="./"><i className="mbx-icon mbx-icon-Arrow_Left mr-2"></i><span className="font-bold label">イベント一覧へ</span></a>
          </div>
        </div>
      </div >
    </div >
  );
};
